import React from 'react';
import {Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

class TopBar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Navbar color="dark" dark expand="md">
        <Container>
          <NavbarBrand href="/">
            {/* <img src={profilePic} className="profile-pic" alt="Oswaldo Díaz"/> */}
            {/* <span>Andry Rajoelimanana</span> */}
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle}/>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="/myhome/home">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/myhome/research">Research</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/myhome/publications">Publications</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/myhome/profile">Profile</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/myhome/project">Projects</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/myhome/contact">Contact</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default TopBar;